module.exports = __webpack_public_path__ + "static/why-diets-fail-v2-3d85866dfe4d1dd2ff2a911badfc5b1a.svg";